/* unplugin-vue-components disabled */import { render } from "./company-tile.vue?vue&type=template&id=e16f6f90&scoped=true"
import script from "./company-tile.vue?vue&type=script&lang=js"
export * from "./company-tile.vue?vue&type=script&lang=js"

import "./company-tile.vue?vue&type=style&index=0&id=e16f6f90&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16f6f90"],['__file',"src/pages/pulse/company-tile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e16f6f90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e16f6f90', __exports__)) {
    api.reload('e16f6f90', __exports__)
  }
  
  module.hot.accept("./company-tile.vue?vue&type=template&id=e16f6f90&scoped=true", () => {
    api.rerender('e16f6f90', render)
  })

}


export default __exports__